import authorize from "./authorize";
import getHost from "./getHost";
import getSubstream from "./getSubstream";
import { isRportPtzEnabled } from "./isRportPtzEnabled";
import issueCommand from "./issueCommand";
import { isWebRTCPTZEnabled } from "./isWebRTCPTZEnabled";

export interface IPTZ {
  getHost(mjpgUrl: string): string;
  getSubstream(mjpgUrl: string): number;
  authorize(mjpgUrl: string): void;
  issueCommand(url: string, callback?: (error?: any) => void): void;
  isWebRTCPTZEnabled(
    stream?: VideoStream,
    features?: StreamFeatures,
    isMobile?: boolean,
    isSmallScreen?: boolean,
    companyId?: string
  ): boolean;
  isRportPtzEnabled(
    stream?: VideoStream,
    features?: StreamFeatures,
    isMobile?: boolean,
    isSmallScreen?: boolean
  ): boolean
}

const PTZ: IPTZ = {
  getHost,
  getSubstream,
  authorize,
  issueCommand,
  isWebRTCPTZEnabled,
  isRportPtzEnabled
}

export default PTZ;
